// revenueManagement: { rate: RateService },

import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputLabel,
} from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, ReactNode, useContext } from 'react';
import { useQuery } from 'react-query';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 10;

export const ColumnsField: FC<{
  value: string[] | null;
  onChange: (value: string[] | null) => void;
  error?: ReactNode;
}> = ({ value, onChange, error }) => {
  const {
    HotelApi: {
      report: {
        reservationReport: {
          forecastByRoomType: { getSettingsColumns },
        },
      },
    },
  } = useContext(RootContext);

  const { isLoading, data } = useQuery({
    queryKey: ['getSettingsColumns'],
    queryFn: () => getSettingsColumns(),
  });

  const handleChange = (id: string) => {
    // const currentValues = value?.map(String) ?? [];
    // const newValues = currentValues.includes(id)
    //   ? currentValues.filter(id => id !== id)
    //   : [...currentValues, id];

    // onChange(newValues.length > 0 ? newValues : null);

    onChange((value || []).includes(id) ? [] : [id]);
  };

  if (isLoading) {
    return <>...</>;
  }

  return (
    <FormControl
      variant="standard"
      fullWidth
      sx={{
        boxShadow: 'inset 0 -1px 0 0 #d2d7de',
        pb: 2,
      }}
    >
      <InputLabel shrink>Columns</InputLabel>
      <Box
        sx={{
          mt: 3,
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          overflow: 'auto',
        }}
      >
        <FormGroup
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {(Object.keys(data || {}) || []).map(key => (
            <FormControlLabel
              key={key}
              control={
                <Checkbox
                  checked={value?.map(String).includes(String(key)) ?? false}
                  onChange={() => handleChange(String(key))}
                  // disabled={(value || [])?.length > 0 && !(value || []).includes(key)}
                  sx={{
                    mr: 1,
                  }}
                />
              }
              label={data![key]}
              sx={{ py: 0.5, pl: 1.5 }}
            />
          ))}
        </FormGroup>
      </Box>
      {Boolean(error) && <FormHelperText error>{error}</FormHelperText>}
    </FormControl>
  );
};
